export const requestInterceptor = (config: any) => {
  config.metadata = { startTime: new Date() };
  return config;
};
